const email1 = {
  id: 1,
  passage: `From: Michael Chen <michael.chen@nexustech.com>
To: Sarah Johnson <sarah.johnson@globalinnovate.com>
Subject: Proposal for Strategic Partnership - NexusTech & Global Innovate

Dear Ms. Johnson,

I hope this email finds you well. Following our productive conversation at the International Tech Conference last month, I am writing to formally propose a strategic partnership between NexusTech and Global Innovate.

As discussed, we believe there is significant potential for synergy between our companies. NexusTech's expertise in cloud infrastructure solutions would <mark>complement</mark> Global Innovate's advanced AI applications, creating a <mark>comprehensive</mark> offering that would provide <mark>substantial</mark> value to clients in the financial services sector.

We envision a partnership that would include:

1. Joint product development for <mark>integrated</mark> AI-powered cloud solutions
2. Shared marketing initiatives targeting enterprise clients
3. <mark>Cross-selling</mark> opportunities across our <mark>respective</mark> client bases
4. Collaborative research on <mark>emerging</mark> technologies

The <mark>enclosed</mark> document <mark>outlines</mark> our proposed partnership structure, including revenue sharing models, resource allocation, and implementation timeline. We estimate that this collaboration could generate additional annual revenue of $3-5 million for each company within the first two years.

I would welcome the opportunity to discuss this proposal in more detail. Would you be available for a video conference next Tuesday at 2:00 PM EST? Alternatively, I could arrange to visit your <mark>headquarters</mark> in Boston later this month.

Thank you for considering this partnership opportunity. I look forward to your response and to the prospect of working together to create innovative solutions for our clients.

Best regards,

Michael Chen
Vice President, Strategic Partnerships
NexusTech Inc.
Tel: (415) 555-7890
michael.chen@nexustech.com`,

  translation: `보낸 사람: Michael Chen <michael.chen@nexustech.com>
받는 사람: Sarah Johnson <sarah.johnson@globalinnovate.com>
제목: 전략적 파트너십 제안 - NexusTech & Global Innovate

존경하는 Johnson 님께,

안녕하세요. 지난달 국제 기술 컨퍼런스에서 나눈 생산적인 대화에 이어, NexusTech와 Global Innovate 간의 전략적 파트너십을 공식적으로 제안하고자 이 이메일을 보냅니다.

논의했던 대로, 저희는 우리 회사들 간에 상당한 시너지 가능성이 있다고 믿습니다. NexusTech의 클라우드 인프라 솔루션 전문성은 Global Innovate의 고급 AI 애플리케이션을 보완하여, 금융 서비스 부문의 고객들에게 상당한 가치를 제공할 수 있는 종합적인 제안을 만들 것입니다.

저희가 구상하는 파트너십은 다음을 포함합니다:

1. 통합 AI 기반 클라우드 솔루션을 위한 공동 제품 개발
2. 기업 고객을 대상으로 하는 공유 마케팅 이니셔티브
3. 각 회사의 고객 기반에 걸친 교차 판매 기회
4. 신흥 기술에 대한 공동 연구

첨부된 문서는 수익 공유 모델, 자원 할당 및 구현 일정을 포함한 저희의 제안된 파트너십 구조를 설명합니다. 이 협력이 첫 2년 내에 각 회사에 연간 300만-500만 달러의 추가 수익을 창출할 수 있을 것으로 예상합니다.

이 제안에 대해 더 자세히 논의할 기회를 환영합니다. 다음 화요일 오후 2시(동부 표준시)에 화상 회의가 가능하신가요? 또는 이달 말에 보스턴에 있는 귀사 본사를 방문할 수도 있습니다.

이 파트너십 기회를 고려해 주셔서 감사합니다. 귀하의 답변과 고객을 위한 혁신적인 솔루션을 함께 만들어 나갈 전망을 기대합니다.

감사합니다,

Michael Chen
부사장, 전략적 파트너십
NexusTech Inc.
전화: (415) 555-7890
michael.chen@nexustech.com`,

  koreanNouns: `From: Michael Chen <michael.chen@nexustech.com>
To: Sarah Johnson <sarah.johnson@globalinnovate.com>
Subject: Proposal for Strategic Partnership - NexusTech & Global Innovate

Dear Ms. Johnson,

I hope this email finds you well. Following our productive conversation at the International Tech Conference last month, I am writing to formally propose a strategic partnership between NexusTech and Global Innovate.

As discussed, we believe there is significant potential for synergy between our companies. NexusTech's expertise in cloud infrastructure solutions would <mark>보완하다</mark> Global Innovate's advanced AI applications, creating a <mark>종합적인</mark> offering that would provide <mark>상당한</mark> value to clients in the financial services sector.

We envision a partnership that would include:

1. Joint product development for <mark>통합된</mark> AI-powered cloud solutions
2. Shared marketing initiatives targeting enterprise clients
3. <mark>교차 판매</mark> opportunities across our <mark>각</mark> client bases
4. Collaborative research on <mark>신흥의</mark> technologies

The <mark>첨부된</mark> document <mark>설명한다</mark> our proposed partnership structure, including revenue sharing models, resource allocation, and implementation timeline. We estimate that this collaboration could generate additional annual revenue of $3-5 million for each company within the first two years.

I would welcome the opportunity to discuss this proposal in more detail. Would you be available for a video conference next Tuesday at 2:00 PM EST? Alternatively, I could arrange to visit your <mark>본사</mark> in Boston later this month.

Thank you for considering this partnership opportunity. I look forward to your response and to the prospect of working together to create innovative solutions for our clients.

Best regards,

Michael Chen
Vice President, Strategic Partnerships
NexusTech Inc.
Tel: (415) 555-7890
michael.chen@nexustech.com`,

  wordPairs: {
    complement: "보완하다",
    comprehensive: "종합적인",
    substantial: "상당한",
    integrated: "통합된",
    "Cross-selling": "교차 판매",
    emerging: "신흥의",
    respective: "각",
    enclosed: "첨부된",
    outlines: "설명한다",
    headquarters: "본사",
  },

  questions: [],
};
const email2 = {
  id: 2,
  passage: `Subject: Q2 <mark>Wrap-Up</mark> and Strategic Outlook for Q3

Dear Team,

I hope this message finds you well. As we reach the end of the second quarter, I wanted to take a moment to update you on our progress and outline our strategies <mark>moving forward</mark>.

Achievements and Milestones
This quarter has been a <mark>testament</mark> to our dedication and teamwork. Here are some of the key achievements:
Increased customer satisfaction by 15% through our enhanced service offerings and faster response times.
Launched three new products (SmartHub Mini, EchoView Monitor, and CleanCharge Pro), which have been <mark>well-received</mark> in the market.
Expanded our team with 20 new hires across sales, product, and customer success departments, strengthening our foundation for future growth.

Challenges and Learnings
While we have much to celebrate, we also <mark>faced</mark> challenges that provided valuable learning experiences:
Supply chain disruptions affected our delivery timelines, particularly for overseas orders. We are now establishing backup vendor relationships and increasing inventory buffers to <mark>mitigate</mark> future risks.
Client feedback revealed areas for improvement in post-purchase communication. Our support and account management teams are now collaborating on a <mark>unified</mark> communication protocol to address this.

Strategic Initiatives for Q3
To build on our successes, we will focus on the following strategic initiatives:
Enhancing our digital marketing strategy to expand brand awareness, strengthen our online presence, and attract new customers in <mark>untapped</mark> regions.
Investing in employee development, including launching a new internal learning platform and hosting quarterly skills workshops.
Optimizing operational workflows, such as automating parts of our order management system to reduce errors and shorten processing times.

Call to Action
Everyone's contribution is vital to our continued success. I encourage you to stay engaged, collaborate across departments, and bring forth innovative ideas that will <mark>propel</mark> us forward. Let's continue to support one another and <mark>uphold</mark> the values of excellence, transparency, and agility that define our company culture.

Thank you for your hard work and dedication. Together, we can achieve great things.

Best regards,
Rachel Kim
Head of Operations
NexaCore Solutions`,
  translation: `제목: Q2 마무리 및 Q3 전략적 전망

친애하는 팀원 여러분,

안녕하세요. 2분기가 끝나가는 시점에서, 우리의 진행 상황을 업데이트하고 앞으로의 전략을 개략적으로 설명해 드리고자 합니다.

성과 및 이정표
이번 분기는 우리의 헌신과 팀워크를 증명하는 시간이었습니다. 다음은 주요 성과입니다:

향상된 서비스 제공과 더 빠른 응답 시간을 통해 고객 만족도를 15% 증가시켰습니다.

새로운 제품 3개(SmartHub Mini, EchoView Monitor, CleanCharge Pro)를 출시했으며, 시장에서 좋은 반응을 얻고 있습니다.

영업, 제품, 고객 성공 부서 전반에 걸쳐 20명의 신규 직원을 채용하여 미래 성장을 위한 기반을 강화했습니다.

도전과 학습
축하할 일이 많지만, 우리는 또한 가치 있는 학습 경험을 제공한 도전에 직면했습니다:

공급망 중단으로 특히 해외 주문에 대한 배송 일정이 영향을 받았습니다. 이제 백업 공급업체 관계를 구축하고 재고 버퍼를 늘려 미래 위험을 완화하고 있습니다.

고객 피드백을 통해 구매 후 커뮤니케이션에서 개선이 필요한 영역이 드러났습니다. 지원 및 계정 관리 팀이 이를 해결하기 위해 통합된 커뮤니케이션 프로토콜을 협력하여 개발하고 있습니다.

Q3 전략적 이니셔티브
우리의 성공을 바탕으로, 다음과 같은 전략적 이니셔티브에 집중할 것입니다:

브랜드 인지도를 확장하고, 온라인 존재감을 강화하며, 미개발 지역에서 새로운 고객을 유치하기 위해 디지털 마케팅 전략을 강화합니다.

새로운 내부 학습 플랫폼 출시 및 분기별 기술 워크숍 개최를 포함한 직원 개발에 투자합니다.

오류를 줄이고 처리 시간을 단축하기 위해 주문 관리 시스템의 일부를 자동화하는 등 운영 워크플로우를 최적화합니다.

행동 촉구
모든 사람의 기여는 우리의 지속적인 성공에 필수적입니다. 부서 간 협력하고, 우리를 앞으로 나아가게 할 혁신적인 아이디어를 제시하며, 참여를 유지하도록 권장합니다. 서로를 지원하고 우리 회사 문화를 정의하는 탁월함, 투명성, 민첩성의 가치를 계속 유지합시다.

여러분의 노고와 헌신에 감사드립니다. 함께라면 우리는 위대한 일을 이룰 수 있습니다.

감사합니다,
Rachel Kim
운영 책임자
NexaCore Solutions`,
  koreanNouns: `Subject: Q2 <mark>마무리</mark> and Strategic Outlook for Q3

Dear Team,

I hope this message finds you well. As we reach the end of the second quarter, I wanted to take a moment to update you on our progress and outline our strategies <mark>앞으로</mark>.

Achievements and Milestones
This quarter has been a <mark>증명</mark> to our dedication and teamwork. Here are some of the key achievements:
Increased customer satisfaction by 15% through our enhanced service offerings and faster response times.
Launched three new products (SmartHub Mini, EchoView Monitor, and CleanCharge Pro), which have been <mark>좋은 반응을 얻고 있습니다</mark> in the market.
Expanded our team with 20 new hires across sales, product, and customer success departments, strengthening our foundation for future growth.

Challenges and Learnings
While we have much to celebrate, we also <mark>직면했다</mark> challenges that provided valuable learning experiences:
Supply chain disruptions affected our delivery timelines, particularly for overseas orders. We are now establishing backup vendor relationships and increasing inventory buffers to <mark>완화하다</mark> future risks.
Client feedback revealed areas for improvement in post-purchase communication. Our support and account management teams are now collaborating on a <mark>통합된</mark> communication protocol to address this.

Strategic Initiatives for Q3
To build on our successes, we will focus on the following strategic initiatives:
Enhancing our digital marketing strategy to expand brand awareness, strengthen our online presence, and attract new customers in <mark>미개발된</mark> regions.
Investing in employee development, including launching a new internal learning platform and hosting quarterly skills workshops.
Optimizing operational workflows, such as automating parts of our order management system to reduce errors and shorten processing times.

Call to Action
Everyone's contribution is vital to our continued success. I encourage you to stay engaged, collaborate across departments, and bring forth innovative ideas that will <mark>나아가게 하다</mark> us forward. Let's continue to support one another and <mark>유지하다</mark> the values of excellence, transparency, and agility that define our company culture.

Thank you for your hard work and dedication. Together, we can achieve great things.

Best regards,
Rachel Kim
Head of Operations
NexaCore Solutions`,
  wordPairs: {
    "Wrap-Up": "마무리",
    "moving forward": "앞으로",
    testament: "증명",
    "well-received": "좋은 반응을 얻고 있습니다",
    faced: "직면했다",
    mitigate: "완화하다",
    unified: "통합된",
    untapped: "미개발된",
    propel: "나아가게 하다",
    uphold: "유지하다",
  },
  questions: [],
};
const email3 = {
  id: 3,
  passage: `Subject: Organizational <mark>Restructuring</mark> Notification

Dear Team,

We are writing to inform you about an upcoming restructuring process that will take place within our organization. This step is essential to ensure our continued growth and ability to adapt to the changing market environment.

Purpose of the Restructuring
The primary goal of this restructuring is to streamline our operations, enhance efficiency, and improve overall performance. By doing this, we aim to better position <mark>ourselves</mark> for future success and ensure our competitiveness in the industry, especially as we expand into new markets and <mark>embrace</mark> digital transformation.

Impact on Teams and Departments
While this process will involve changes across various teams and departments, we are committed to managing this transition as smoothly as possible. Our priority is to minimize disruption, maintain transparency, and support all affected employees throughout the process.

Key Changes
Reallocation of resources to prioritize our core business units: product innovation, customer success, and enterprise partnerships
Realignment of certain departments to improve synergy, reduce <mark>redundancies</mark>, and <mark>foster</mark> cross-functional collaboration
Introduction of new roles, including Data Strategy Lead and Customer Insights Manager, to support long-term strategic goals

Support and Resources
We understand that change can be <mark>challenging</mark>, and we are here to support you through this transition. The HR team, along with department heads, will provide:

Access to transition coaching and internal mobility support

Updated FAQs and organizational charts
One-on-one sessions to address your specific questions or concerns

Please feel free to reach out to your manager or HR representative if you need assistance or more <mark>clarity</mark>.

Next Steps
We will be holding department-level meetings over the next two weeks to walk you through the restructuring plan in detail. These meetings will give you a chance to <mark>voice</mark> your thoughts and better understand how these changes affect your team.

Thank you for your continued dedication and professionalism. Together, we will navigate this transition and <mark>emerge</mark> as a stronger, more focused organization.

Sincerely,
Angela Torres
Chief Operating Officer
StratusNova Inc.`,
  translation: `제목: 조직 구조 개편 알림

친애하는 팀원 여러분,

저희 조직 내에서 진행될 예정인 구조 개편 과정에 대해 알려드리고자 합니다. 이 단계는 지속적인 성장과 변화하는 시장 환경에 적응하는 능력을 보장하기 위해 필수적입니다.

구조 개편의 목적
이 구조 개편의 주요 목표는 운영을 간소화하고, 효율성을 향상시키며, 전반적인 성과를 개선하는 것입니다. 이를 통해 미래의 성공을 위한 더 나은 위치를 확보하고, 특히 새로운 시장으로 확장하고 디지털 변환을 수용함에 따라 업계에서의 경쟁력을 보장하고자 합니다.

팀 및 부서에 미치는 영향
이 과정은 다양한 팀과 부서에 걸쳐 변화를 수반하겠지만, 저희는 이 전환을 가능한 한 원활하게 관리하기 위해 최선을 다하고 있습니다. 저희의 우선순위는 혼란을 최소화하고, 투명성을 유지하며, 영향을 받는 모든 직원들을 과정 전반에 걸쳐 지원하는 것입니다.

주요 변경 사항
제품 혁신, 고객 성공, 기업 파트너십과 같은 핵심 사업 부문을 우선시하기 위한 자원 재할당

시너지를 개선하고, 중복을 줄이며, 부서 간 협력을 촉진하기 위한 특정 부서의 재조정

장기적인 전략적 목표를 지원하기 위한 데이터 전략 책임자 및 고객 인사이트 매니저와 같은 새로운 역할 도입

지원 및 자원
변화가 어려울 수 있다는 것을 이해하며, 이 전환 과정에서 여러분을 지원하기 위해 여기 있습니다. HR 팀과 부서장들은 다음을 제공할 것입니다:

전환 코칭 및 내부 이동성 지원에 대한 접근

업데이트된 FAQ 및 조직도

여러분의 특정 질문이나 우려 사항을 해결하기 위한 일대일 세션

도움이나 더 명확한 설명이 필요하시면 언제든지 매니저나 HR 담당자에게 연락하시기 바랍니다.

다음 단계
앞으로 2주 동안 부서별 회의를 개최하여 구조 개편 계획에 대해 자세히 안내해 드릴 예정입니다. 이 회의는 여러분의 생각을 표현하고 이러한 변화가 팀에 어떤 영향을 미치는지 더 잘 이해할 수 있는 기회가 될 것입니다.

지속적인 헌신과 전문성에 감사드립니다. 함께, 우리는 이 전환을 헤쳐 나가고 더 강하고 집중된 조직으로 거듭날 것입니다.

감사합니다,
Angela Torres
최고운영책임자
StratusNova Inc.`,
  koreanNouns: `Subject: Organizational <mark>구조 개편</mark> Notification

Dear Team,

We are writing to inform you about an upcoming restructuring process that will take place within our organization. This step is essential to ensure our continued growth and ability to adapt to the changing market environment.

Purpose of the Restructuring
The primary goal of this restructuring is to streamline our operations, enhance efficiency, and improve overall performance. By doing this, we aim to better position <mark>우리</mark> for future success and ensure our competitiveness in the industry, especially as we expand into new markets and <mark>수용하다</mark> digital transformation.

Impact on Teams and Departments
While this process will involve changes across various teams and departments, we are committed to managing this transition as smoothly as possible. Our priority is to minimize disruption, maintain transparency, and support all affected employees throughout the process.

Key Changes
Reallocation of resources to prioritize our core business units: product innovation, customer success, and enterprise partnerships.
Realignment of certain departments to improve synergy, reduce <mark>중복들</mark>, and <mark>촉진하다</mark> cross-functional collaboration
Introduction of new roles, including Data Strategy Lead and Customer Insights Manager, to support long-term strategic goals

Support and Resources
We understand that change can be <mark>어려운</mark>, and we are here to support you through this transition. The HR team, along with department heads, will provide:

Access to transition coaching and internal mobility support

Updated FAQs and organizational charts
One-on-one sessions to address your specific questions or concerns

Please feel free to reach out to your manager or HR representative if you need assistance or more <mark>명확성</mark>.

Next Steps
We will be holding department-level meetings over the next two weeks to walk you through the restructuring plan in detail. These meetings will give you a chance to <mark>표현하다</mark> your thoughts and better understand how these changes affect your team.

Thank you for your continued dedication and professionalism. Together, we will navigate this transition and <mark>거듭나다</mark> as a stronger, more focused organization.

Sincerely,
Angela Torres
Chief Operating Officer
StratusNova Inc.`,
  wordPairs: {
    restructuring: "구조 개편",
    ourselves: "우리",
    embrace: "수용하다",
    redundancies: "중복들",
    foster: "촉진하다",
    challenging: "어려운",
    clarity: "명확성",
    voice: "표현하다",
    emerge: "거듭나다",
  },
  questions: [],
};
const email4 = {
  id: 4,
  passage: `Subject: Important Announcement – NexWave Has Joined Forces with Coreon Group

Dear Team,

I hope this message finds you well. I am writing to share an important and exciting development regarding the future of our company.

As of April 1, 2025, NexWave Inc. has officially been acquired by Coreon Group, a global leader in enterprise software solutions. This strategic move marks a new chapter in our journey and opens the door to greater opportunities, innovation, and growth for all of us.

What This Means for You
No Immediate Changes: Your current roles, teams, and reporting structures will remain unchanged during the initial transition period.

More Resources: With Coreon's backing, we will gain access to expanded technology, infrastructure, and expertise to support your work.

Shared Vision: NexWave's commitment to product excellence and customer success will continue, now strengthened by Coreon's global reach.

What's Next
In the coming weeks, we will hold team briefings and Q&A sessions to share more details and answer any questions you may have.
We are working closely with Coreon's leadership to ensure that the <mark>integration</mark> process is smooth, transparent, and supportive.

Our Promise
We understand that change can bring <mark>uncertainty</mark>. Please know that our people remain our top priority. Your contributions have brought us to this point, and we are confident that this new partnership will <mark>empower</mark> each of you to grow and <mark>thrive</mark>.

If you have any immediate concerns, feel free to reach out to your manager or to our HR team at hr@nexwave.com.

Thank you for your continued dedication. Together, we look forward to building an even stronger future.

Warm regards,
Michael Sung
CEO, NexWave Inc.`,
  translation: `제목: 중요 공지 – NexWave가 Coreon Group과 합병했습니다

친애하는 팀원 여러분,

안녕하세요. 우리 회사의 미래에 관한 중요하고 흥미로운 발전 사항을 공유하고자 합니다.

2025년 4월 1일부로, NexWave Inc.는 기업용 소프트웨어 솔루션 분야의 글로벌 리더인 Coreon Group에 공식적으로 인수되었습니다. 이러한 전략적 움직임은 우리 여정의 새로운 장을 열고, 우리 모두에게 더 큰 기회, 혁신, 그리고 성장의 문을 열어줍니다.

이것이 여러분에게 의미하는 바
즉각적인 변화 없음: 초기 전환 기간 동안 여러분의 현재 역할, 팀, 보고 구조는 변경되지 않을 것입니다.

더 많은 자원: Coreon의 지원으로, 우리는 여러분의 업무를 지원하기 위한 확장된 기술, 인프라, 전문 지식에 접근할 수 있게 됩니다.

공유된 비전: NexWave의 제품 우수성과 고객 성공에 대한 약속은 계속될 것이며, 이제 Coreon의 글로벌 영향력으로 강화됩니다.

다음 단계
앞으로 몇 주 동안, 우리는 더 많은 세부 정보를 공유하고 여러분이 가질 수 있는 질문에 답변하기 위한 팀 브리핑과 Q&A 세션을 개최할 예정입니다.
우리는 통합 과정이 원활하고, 투명하며, 지원적이도록 Coreon의 리더십과 긴밀히 협력하고 있습니다.

우리의 약속
변화가 불확실성을 가져올 수 있다는 것을 이해합니다. 우리의 사람들이 최우선 순위로 남아 있음을 알아주세요. 여러분의 기여가 우리를 이 지점까지 이끌어 왔으며, 이 새로운 파트너십이 여러분 각자가 성장하고 번창할 수 있도록 힘을 실어줄 것이라고 확신합니다.

즉각적인 우려 사항이 있으시면, 여러분의 매니저나 HR 팀(hr@nexwave.com)에 연락하시기 바랍니다.

계속된 헌신에 감사드립니다. 함께, 우리는 더욱 강력한 미래를 구축하기를 기대합니다.

감사합니다,
Michael Sung
CEO, NexWave Inc.`,
  koreanNouns: `Subject: Important Announcement – NexWave Has Joined Forces with Coreon Group

Dear Team,

I hope this message finds you well. I am writing to share an important and exciting development regarding the future of our company.

As of April 1, 2025, NexWave Inc. has officially been acquired by Coreon Group, a global leader in enterprise software solutions. This strategic move marks a new chapter in our journey and opens the door to greater opportunities, innovation, and growth for all of us.

What This Means for You
No Immediate Changes: Your current roles, teams, and reporting structures will remain unchanged during the initial transition period.

More Resources: With Coreon's backing, we will gain access to expanded technology, infrastructure, and expertise to support your work.

Shared Vision: NexWave's commitment to product excellence and customer success will continue, now strengthened by Coreon's global reach.

What's Next
In the coming weeks, we will hold team briefings and Q&A sessions to share more details and answer any questions you may have.
We are working closely with Coreon's leadership to ensure that the <mark>통합</mark> process is smooth, transparent, and supportive.

Our Promise
We understand that change can bring <mark>불확실성</mark>. Please know that our people remain our top priority. Your contributions have brought us to this point, and we are confident that this new partnership will <mark>힘을 실어주다</mark> each of you to grow and <mark>번창하다</mark>.

If you have any immediate concerns, feel free to reach out to your manager or to our HR team at hr@nexwave.com.

Thank you for your continued dedication. Together, we look forward to building an even stronger future.

Warm regards,
Michael Sung
CEO, NexWave Inc.`,
  wordPairs: {
    integration: "통합",
    uncertainty: "불확실성",
    empower: "힘을 실어주다",
    thrive: "번창하다",
  },
  questions: [],
};
const email5 = {
  id: 5,
  passage: `From: Mina Jang mina.jang@lunaralabs.com
To: All Employees
Subject: Announcement of Brand Renewal Strategy
Date: March 25, 2025

Dear Team,

I'm excited to announce that we are officially launching a brand renewal strategy for Lunara Labs.

As our company continues to grow and expand into new markets, it is essential that our brand reflects our mission and vision. This renewal is not just about a new look—it represents a repositioning of our identity to better connect with our audience and highlight our innovative values.

Key changes include a refreshed logo and visual identity, updated messaging and tone, a redesigned website, and new product <mark>packaging</mark>. These changes aim to present a more modern, bold, and <mark>cohesive</mark> image across all <mark>touchpoints</mark>.

We will begin the <mark>rollout</mark> next week, starting with internal materials. Please keep an eye out for the new Brand Style Guide and training sessions for relevant teams.

Your support is vital to the success of this transition. Let's move forward together and make this new chapter in Lunara Labs a memorable one.

Best regards,
Mina Jang
Chief Marketing Officer
Lunara Labs`,
  translation: `보낸 사람: Mina Jang mina.jang@lunaralabs.com
받는 사람: 모든 직원
제목: 브랜드 리뉴얼 전략 발표
날짜: 2025년 3월 25일

친애하는 팀원 여러분,

루나라 랩스의 브랜드 리뉴얼 전략을 공식적으로 시작한다는 소식을 알려드리게 되어 기쁩니다.

우리 회사가 계속 성장하고 새로운 시장으로 확장함에 따라, 우리의 브랜드가 우리의 사명과 비전을 반영하는 것이 필수적입니다. 이번 리뉴얼은 단순히 새로운 모습에 관한 것이 아니라—우리의 청중과 더 잘 연결되고 혁신적인 가치를 강조하기 위한 우리 정체성의 재배치를 나타냅니다.

주요 변경 사항으로는 새롭게 단장된 로고와 시각적 정체성, 업데이트된 메시징과 톤, 재설계된 웹사이트, 그리고 새로운 제품 포장이 있습니다. 이러한 변화들은 모든 접점에서 더 현대적이고, 대담하며, 일관된 이미지를 제시하는 것을 목표로 합니다.

다음 주부터 내부 자료부터 시작하여 출시를 시작할 예정입니다. 새로운 브랜드 스타일 가이드와 관련 팀을 위한 교육 세션에 주목해 주세요.

여러분의 지원은 이번 전환의 성공에 필수적입니다. 함께 앞으로 나아가 루나라 랩스의 이 새로운 장을 기억에 남는 것으로 만들어 봅시다.

감사합니다,
Mina Jang
최고 마케팅 책임자
루나라 랩스`,
  koreanNouns: `From: Mina Jang mina.jang@lunaralabs.com
To: All Employees
Subject: Announcement of Brand Renewal Strategy
Date: March 25, 2025

Dear Team,

I'm excited to announce that we are officially launching a brand renewal strategy for Lunara Labs.

As our company continues to grow and expand into new markets, it is essential that our brand reflects our mission and vision. This renewal is not just about a new look—it represents a repositioning of our identity to better connect with our audience and highlight our innovative values.

Key changes include a refreshed logo and visual identity, updated messaging and tone, a redesigned website, and new product <mark>포장</mark>. These changes aim to present a more modern, bold, and <mark>일관된</mark> image across all <mark>접점</mark>.

We will begin the <mark>출시</mark> next week, starting with internal materials. Please keep an eye out for the new Brand Style Guide and training sessions for relevant teams.

Your support is vital to the success of this transition. Let's move forward together and make this new chapter in Lunara Labs a memorable one.

Best regards,
Mina Jang
Chief Marketing Officer
Lunara Labs`,
  wordPairs: {
    packaging: "포장",
    cohesive: "일관된",
    touchpoints: "접점",
    rollout: "출시",
  },
  questions: [],
};
const email6 = {
  id: 6,
  passage: `Subject: Proposal for Re-Collaboration Opportunity

Dear Mr. Takahashi,

I hope this email finds you well. I am writing to propose a potential re-collaboration opportunity between our companies, building on the successful outcomes of our previous <mark>transactions</mark>. Our past partnership has demonstrated mutually beneficial results, and I believe there are further possibilities for us to explore together.

Reflecting on our past engagements, our collaboration has been marked by increased market reach in the Japanese retail sector and successful <mark>co-launch</mark> of the EcoLite Smart Lamp. These <mark>accomplishments</mark> have paved the way for a strong foundation on which we can build future projects.

Achievements from Past Collaborations
-Successfully launched EcoLite Smart Lamp, leading to a 22% increase in monthly sales
-Increased sales volume by 35% within Q2 2050
-Enhanced customer satisfaction, as highlighted by positive feedback in post-purchase surveys

To capitalize on the momentum we have built, I propose that we explore the following opportunities for re-collaboration:

-<mark>Joint development</mark> of a new smart lighting line tailored to the eco-conscious urban consumer market
-Expansion of our current offerings through improved AI-based lighting control and automation technology
-Co-marketing initiatives, including social media campaigns and influencer partnerships, to boost brand visibility across Asia-Pacific

Next Steps
I would appreciate the opportunity to discuss this proposal further. Please let me know if you are available for a meeting next week. I am confident that by <mark>leveraging</mark> our combined strengths, we can achieve <mark>noteworthy</mark> success once again.

Thank you for considering this re-collaboration opportunity. I look forward to your positive response.

Warm regards,
Lena Park
Partnership Manager
Aurora Tech Solutions`,
  translation: `제목: 재협업 기회 제안

다카하시 님께,

안녕하세요. 저는 이전 거래의 성공적인 결과를 바탕으로 우리 회사 간의 잠재적인 재협업 기회를 제안하고자 이메일을 보냅니다. 우리의 과거 파트너십은 상호 이익이 되는 결과를 보여주었으며, 함께 탐색할 수 있는 더 많은 가능성이 있다고 생각합니다.

과거 협업을 돌아보면, 우리의 협력은 일본 소매 부문에서의 시장 도달 범위 증가와 에코라이트 스마트 램프의 성공적인 공동 출시로 특징지어졌습니다. 이러한 성과들은 우리가 미래 프로젝트를 구축할 수 있는 강력한 기반을 마련했습니다.

과거 협업의 성과
-에코라이트 스마트 램프를 성공적으로 출시하여 월간 판매량 22% 증가
-2050년 2분기 내 판매량 35% 증가
-구매 후 설문조사에서 긍정적인 피드백으로 강조된 고객 만족도 향상

우리가 구축한 모멘텀을 활용하기 위해, 다음과 같은 재협업 기회를 탐색할 것을 제안합니다:

-환경 의식이 있는 도시 소비자 시장에 맞춘 새로운 스마트 조명 라인의 공동 개발

-AI 기반 조명 제어 및 자동화 기술을 통한 현재 제품 라인의 확장

-아시아-태평양 지역 전체에서 브랜드 가시성을 높이기 위한 소셜 미디어 캠페인 및 인플루언서 파트너십을 포함한 공동 마케팅 이니셔티브

다음 단계
이 제안에 대해 더 논의할 기회를 갖고 싶습니다. 다음 주에 미팅이 가능하신지 알려주시기 바랍니다. 우리의 결합된 강점을 활용함으로써 다시 한번 주목할 만한 성공을 이룰 수 있다고 확신합니다.

이 재협업 기회를 고려해 주셔서 감사합니다. 긍정적인 답변을 기대합니다.

감사합니다,
레나 박
파트너십 매니저
오로라 테크 솔루션`,
  koreanNouns: `Subject: Proposal for Re-Collaboration Opportunity

Dear Mr. Takahashi,

I hope this email finds you well. I am writing to propose a potential re-collaboration opportunity between our companies, building on the successful outcomes of our previous <mark>거래</mark>. Our past partnership has demonstrated mutually beneficial results, and I believe there are further possibilities for us to explore together.

Reflecting on our past engagements, our collaboration has been marked by increased market reach in the Japanese retail sector and successful <mark>공동 출시</mark> of the EcoLite Smart Lamp. These <mark>성과</mark> have paved the way for a strong foundation on which we can build future projects.

Achievements from Past Collaborations
-Successfully launched EcoLite Smart Lamp, leading to a 22% increase in monthly sales
-Increased sales volume by 35% within Q2 2050
-Enhanced customer satisfaction, as highlighted by positive feedback in post-purchase surveys

To capitalize on the momentum we have built, I propose that we explore the following opportunities for re-collaboration:

-<mark>공동 개발</mark> of a new smart lighting line tailored to the eco-conscious urban consumer market
-Expansion of our current offerings through improved AI-based lighting control and automation technology
-Co-marketing initiatives, including social media campaigns and influencer partnerships, to boost brand visibility across Asia-Pacific

Next Steps
I would appreciate the opportunity to discuss this proposal further. Please let me know if you are available for a meeting next week. I am confident that by <mark>활용하다</mark> our combined strengths, we can achieve <mark>주목할 만한</mark> success once again.

Thank you for considering this re-collaboration opportunity. I look forward to your positive response.

Warm regards,
Lena Park
Partnership Manager
Aurora Tech Solutions`,
  wordPairs: {
    "Joint development": "공동 개발",
    leveraging: "활용하다",
    noteworthy: "주목할 만한",
    transactions: "거래",
    "co-launch": "공동 출시",
    accomplishments: "성과",
  },
  questions: [],
};
const email7 = {
  id: 7,
  passage: `Subject: Proposal for Collaborative Research and Development

Dear Dr. Elena Foster,

I hope this message finds you well. My name is Thomas Han, and I am the Director of Research Partnerships at AetherBio Solutions. We have been <mark>deeply</mark> impressed by your innovative work in the field of synthetic biology and are writing to propose an exciting opportunity for <mark>collaborative</mark> research and development between our organizations.

The primary objective of this collaboration is to combine our respective strengths to advance research in next-generation gene editing systems. By leveraging our collective expertise, we aim to achieve groundbreaking results that will benefit both <mark>parties</mark> and contribute positively to the biotechnology industry as a whole.

Proposed Areas of Collaboration

We have identified several key areas where we believe our collaboration could be particularly <mark>fruitful</mark>:

-Joint development of innovative technologies in CRISPR-based delivery mechanisms
-Research into precision genome editing solutions for rare genetic disorders
-Sharing of data and laboratory resources for <mark>mutual</mark> benefit
-Co-authorship of academic papers, white papers, and industry reports

Benefits of Collaboration

By partnering on this venture, we anticipate the following benefits:
-Access to a <mark>broader</mark> range of technical expertise and equipment
-Accelerated research timelines and increased publication output
-Enhanced visibility and reputation in academic and industry circles
-Potential for <mark>patent</mark> filings and <mark>commercialization</mark> of jointly developed technologies

We would be delighted to discuss this proposal in more detail and explore the potential synergies between our organizations. Please let us know a convenient time for you to hold an initial meeting, either <mark>virtually</mark> or in person. We are eager to <mark>embark on</mark> this journey together and <mark>forge</mark> a successful and <mark>mutually</mark> beneficial partnership.

Thank you for considering this proposal. We look forward to your positive response.

Best regards,
Thomas Han
Director of Research Partnerships
AetherBio Solutions`,
  translation: `제목: 공동 연구 및 개발 제안

친애하는 엘레나 포스터 박사님께,

안녕하세요. 저는 에테르바이오 솔루션의 연구 파트너십 디렉터인 토마스 한입니다. 저희는 합성 생물학 분야에서의 귀하의 혁신적인 연구에 깊은 인상을 받았으며, 우리 조직 간의 흥미로운 공동 연구 및 개발 기회를 제안하고자 합니다.

이 협력의 주요 목표는 차세대 유전자 편집 시스템 연구를 발전시키기 위해 우리의 각 강점을 결합하는 것입니다. 우리의 집단적 전문성을 활용함으로써, 양측에 이익이 되고 생명공학 산업 전체에 긍정적으로 기여할 획기적인 결과를 달성하고자 합니다.

제안된 협력 분야

우리는 협력이 특히 유익할 수 있는 몇 가지 주요 영역을 확인했습니다:

-CRISPR 기반 전달 메커니즘의 혁신적인 기술 공동 개발
-희귀 유전 질환을 위한 정밀 게놈 편집 솔루션 연구
-상호 이익을 위한 데이터 및 실험실 자원 공유
-학술 논문, 백서 및 산업 보고서의 공동 저작

협력의 이점

이 벤처에 파트너십을 맺음으로써, 우리는 다음과 같은 이점을 예상합니다:
더 넓은 범위의 기술적 전문 지식과 장비에 대한 접근
가속화된 연구 일정 및 증가된 출판물 산출
학계 및 산업계에서의 향상된 가시성 및 평판
공동 개발된 기술의 특허 출원 및 상업화 가능성

이 제안에 대해 더 자세히 논의하고 우리 조직 간의 잠재적 시너지를 탐색할 수 있기를 기대합니다. 가상 또는 직접 만남으로 초기 회의를 할 수 있는 편리한 시간을 알려주시기 바랍니다. 우리는 함께 이 여정을 시작하고 성공적이고 상호 이익이 되는 파트너십을 구축하기를 간절히 바랍니다.

이 제안을 고려해 주셔서 감사합니다. 긍정적인 답변을 기대합니다.

감사합니다,
토마스 한
연구 파트너십 디렉터
에테르바이오 솔루션`,
  koreanNouns: `Subject: Proposal for Collaborative Research and Development

Dear Dr. Elena Foster,

I hope this message finds you well. My name is Thomas Han, and I am the Director of Research Partnerships at AetherBio Solutions. We have been <mark>깊은</mark> impressed by your innovative work in the field of synthetic biology and are writing to propose an exciting opportunity for <mark>협력적인</mark> research and development between our organizations.

The primary objective of this collaboration is to combine our respective strengths to advance research in next-generation gene editing systems. By leveraging our collective expertise, we aim to achieve groundbreaking results that will benefit both <mark>당사자들</mark> and contribute positively to the biotechnology industry as a whole.

Proposed Areas of Collaboration

We have identified several key areas where we believe our collaboration could be particularly <mark>결실이 많은</mark>:

-Joint development of innovative technologies in CRISPR-based delivery mechanisms
-Research into precision genome editing solutions for rare genetic disorders
-Sharing of data and laboratory resources for <mark>상호적인</mark> benefit
-Co-authorship of academic papers, white papers, and industry reports

Benefits of Collaboration

By partnering on this venture, we anticipate the following benefits:
-Access to a <mark>더 넓은</mark> range of technical expertise and equipment
-Accelerated research timelines and increased publication output
-Enhanced visibility and reputation in academic and industry circles
-Potential for <mark>특허</mark> filings and <mark>상업화</mark> of jointly developed technologies

We would be delighted to discuss this proposal in more detail and explore the potential synergies between our organizations. Please let us know a convenient time for you to hold an initial meeting, either <mark>가상으로</mark> or in person. We are eager to <mark>시작하다</mark> this journey together and <mark>구축하다</mark> a successful and <mark>상호적으로</mark> beneficial partnership.

Thank you for considering this proposal. We look forward to your positive response.

Best regards,
Thomas Han
Director of Research Partnerships
AetherBio Solutions`,
  wordPairs: {
    deeply: "깊은",
    collaborative: "협력적인",
    parties: "당사자들",
    fruitful: "결실이 많은",
    mutual: "상호적인",
    broader: "더 넓은",
    patent: "특허",
    commercialization: "상업화",
    virtually: "가상으로",
    "embark on": "시작하다",
    forge: "구축하다",
    mutually: "상호적으로",
  },
  questions: [],
};
const email8 = {
  id: 7,
  passage: `Subject: Proposal for Regular Supply Agreement

Dear Mr. Jonathan Lee,

I hope this message finds you well. I am writing to propose a regular supply agreement between our companies that could offer mutual benefits and streamline our ongoing operations.

At Everpure Chemicals Ltd., we have developed an efficient supply chain that not only ensures timely delivery but also maintains high-quality standards across all of our products. We believe that by establishing a regular supply agreement, we can enhance operational efficiency and foster a long-term, collaborative partnership with Greenwave Manufacturing Co..

Our proposal for a regular supply agreement comes with several benefits:
-Consistent and reliable product availability
-<mark>Stable</mark> pricing and potential for bulk discounts
-Streamlined <mark>procurement</mark> processes
-Enhanced communication and <mark>dedicated</mark> support services

Proposed Terms and Conditions
1.Supply Volume and Frequency
We propose to supply industrial-grade cleaning solvents (Product Code: EP-340) on a monthly basis, amounting to 1,000 liters per month.

2. Pricing and Payment Terms
Our <mark>competitive</mark> pricing model will be based on $3.25 per liter FOB. Payment terms are <mark>negotiable</mark>, but typically we operate on a Net 30 day period.

3. Quality Assurance
We are committed to maintaining the highest standards of quality. All products undergo multi-stage quality control before <mark>dispatch</mark>, and batch testing reports can be provided upon request.

We would appreciate the opportunity to discuss this proposal further and address any questions you may have. Please let us know a convenient time for an online meeting or a phone call.

Thank you for considering our proposal. We look forward to the possibility of working together and creating a productive partnership.

Sincerely,
Hannah Kim
Sales Manager`,
  translation: `제목: 정기 공급 계약 제안

친애하는 조나단 리 님께,

안녕하세요. 저는 우리 회사들 간의 상호 이익을 제공하고 진행 중인 운영을 간소화할 수 있는 정기 공급 계약을 제안하고자 합니다.

에버퓨어 케미컬스 주식회사에서는 시기적절한 배송을 보장할 뿐만 아니라 모든 제품에 걸쳐 높은 품질 표준을 유지하는 효율적인 공급망을 개발했습니다. 정기 공급 계약을 체결함으로써 운영 효율성을 향상시키고 그린웨이브 제조 주식회사와 장기적이고 협력적인 파트너십을 조성할 수 있다고 믿습니다.

정기 공급 계약에 대한 우리의 제안은 다음과 같은 여러 이점을 제공합니다:
-일관되고 신뢰할 수 있는 제품 가용성
-안정적인 가격 책정 및 대량 할인 가능성
-간소화된 조달 프로세스
-향상된 커뮤니케이션 및 전담 지원 서비스

제안된 조건
1. 공급량 및 빈도
월 1,000리터에 해당하는 산업용 세정 용제(제품 코드: EP-340)를 매월 공급할 것을 제안합니다.

2. 가격 책정 및 지불 조건
우리의 경쟁력 있는 가격 모델은 리터당 $3.25 FOB를 기준으로 합니다. 지불 조건은 협상 가능하지만, 일반적으로 우리는 30일 순 기간으로 운영합니다.

3. 품질 보증
우리는 최고 수준의 품질을 유지하기 위해 최선을 다하고 있습니다. 모든 제품은 발송 전에 다단계 품질 관리를 거치며, 요청 시 배치 테스트 보고서를 제공할 수 있습니다.

이 제안에 대해 더 논의하고 귀하가 가질 수 있는 질문에 답변할 기회를 갖게 되어 감사할 것입니다. 온라인 회의나 전화 통화에 편리한 시간을 알려주시기 바랍니다.

우리의 제안을 고려해 주셔서 감사합니다. 함께 일하고 생산적인 파트너십을 만들 가능성을 기대합니다.

감사합니다,
한나 김
영업 관리자`,
  koreanNouns: `Subject: Proposal for Regular Supply Agreement

Dear Mr. Jonathan Lee,

I hope this message finds you well. I am writing to propose a regular supply agreement between our companies that could offer mutual benefits and streamline our ongoing operations.

At Everpure Chemicals Ltd., we have developed an efficient supply chain that not only ensures timely delivery but also maintains high-quality standards across all of our products. We believe that by establishing a regular supply agreement, we can enhance operational efficiency and foster a long-term, collaborative partnership with Greenwave Manufacturing Co..

Our proposal for a regular supply agreement comes with several benefits:
-Consistent and reliable product availability
-<mark>안정적인</mark> pricing and potential for bulk discounts
-Streamlined <mark>조달</mark> processes
-Enhanced communication and <mark>전담</mark> support services

Proposed Terms and Conditions
1.Supply Volume and Frequency
We propose to supply industrial-grade cleaning solvents (Product Code: EP-340) on a monthly basis, amounting to 1,000 liters per month.

2. Pricing and Payment Terms
Our <mark>경쟁력 있는</mark> pricing model will be based on $3.25 per liter FOB. Payment terms are <mark>협상 가능</mark>, but typically we operate on a Net 30 day period.

3. Quality Assurance
We are committed to maintaining the highest standards of quality. All products undergo multi-stage quality control before <mark>발송</mark>, and batch testing reports can be provided upon request.

We would appreciate the opportunity to discuss this proposal further and address any questions you may have. Please let us know a convenient time for an online meeting or a phone call.

Thank you for considering our proposal. We look forward to the possibility of working together and creating a productive partnership.

Sincerely,
Hannah Kim
Sales Manager`,
  wordPairs: {
    stable: "안정적인",
    procurement: "조달",
    dedicated: "전담",
    competitive: "경쟁력 있는",
    negotiable: "협상 가능",
    dispatch: "발송",
  },
  questions: [],
};
const email9 = {
  id: 9,
  passage: `Subject: Request for Assistance with Marketing Campaign

Dear Mr. Thompson,

I hope you are doing well. We are currently preparing a new marketing campaign for the upcoming product <mark>launch</mark> and would greatly appreciate your team's expertise in designing promotional materials.

Specifically we require assistance with:

Creating digital advertisements for online platforms
Designing brochures and print materials for distribution
Would you be available for a <mark>brief</mark> call next week to discuss the project details? Please let me know your availability, and I will arrange a meeting at your convenience.

Your support would be <mark>invaluable</mark> to the success of this campaign. I look forward to your response.

Best regards,
Sophia Mitchell
Marketing Manager`,

  translation: `제목: 마케팅 캠페인 지원 요청

Thompson님께,

안녕하십니까. 저희는 현재 새로운 제품 출시를 위한 마케팅 캠페인을 준비 중이며, 홍보 자료 디자인에 대한 귀 팀의 전문성을 지원받고자 합니다.

구체적으로, 다음 사항들에 대한 지원이 필요합니다:

온라인 플랫폼용 디지털 광고 제작
배포용 브로셔 및 인쇄물 디자인
다음 주에 프로젝트 세부사항을 논의하기 위한 간단한 통화가 가능하신가요? 가능하신 시간을 알려주시면 편하신 때로 회의를 조정하도록 하겠습니다.

귀하의 지원은 이 캠페인의 성공에 매우 중요할 것입니다. 답변을 기다리겠습니다.

감사합니다.
[Sophia Mitchell]
마케팅 매니저`,

  koreanNouns: `Subject: Request for Assistance with Marketing Campaign

Dear Mr. Thompson,

I hope you are doing well. We are currently preparing a new marketing campaign for the upcoming product <mark>출시</mark> and would greatly appreciate your team's expertise in designing promotional materials.

Specifically we require assistance with:

Creating digital advertisements for online platforms
Designing brochures and print materials for distribution
Would you be available for a <mark>짧은</mark> call next week to discuss the project details? Please let me know your availability, and I will arrange a meeting at your convenience.

Your support would be <mark>매우 중요한</mark> to the success of this campaign. I look forward to your response.

Best regards,
Sophia Mitchell
Marketing Manager`,
  wordPairs: {
    brief: "짧은",
    invaluable: "매우 중요한",
    launch: "출시",
  },

  questions: [],
};

const email10 = {
  id: 10,
  passage: `Subject: Thank You for Your Hard Work and Dedication

Dear Team,

I would like to take this opportunity to <mark>extend</mark> my gratitude for your hard work and dedication over the past quarter. Your <mark>commitment</mark> to excellence has significantly contributed to our company's success.

In particular, I would like to recognize the sales and marketing departments for their <mark>outstanding</mark> efforts in exceeding our quarterly targets. Your determination and teamwork have not gone <mark>unnoticed</mark>, and I truly appreciate your contributions.

Thank you once again for your dedication. I look forward to achieving even greater success together in the coming months.

Best regards,
Jonathan Mitchell
Chief Executive Officer`,

  translation: `제목: 열심히 일해주시고 헌신해 주셔서 감사합니다

팀원 여러분,

지난 분기 동안 보여주신 여러분의 노고와 헌신에 감사드리고자 합니다. 여러분의 탁월함에 대한 헌신이 우리 회사의 성공에 크게 기여했습니다.

특히 분기별 목표를 초과 달성한 영업부와 마케팅부의 뛰어난 노력을 인정하고 싶습니다. 여러분의 결단력과 팀워크는 주목받았으며, 여러분의 기여에 진심으로 감사드립니다.

다시 한 번 여러분의 헌신에 감사드립니다. 앞으로 몇 달 동안 함께 더 큰 성공을 이루기를 기대합니다.

감사합니다.
Jonathan Mitchell
최고경영자`,

  koreanNouns: `Subject: Thank You for Your Hard Work and Dedication

Dear Team,

I would like to take this opportunity to <mark>전하다</mark> my gratitude for your hard work and dedication over the past quarter. Your <mark>헌신</mark> to excellence has significantly contributed to our company's success.

In particular, I would like to recognize the sales and marketing departments for their <mark>뛰어난</mark> efforts in exceeding our quarterly targets. Your determination and teamwork have not gone <mark>주목받지 않은</mark>, and I truly appreciate your contributions.

Thank you once again for your dedication. I look forward to achieving even greater success together in the coming months.

Best regards,
Jonathan Mitchell
Chief Executive Officer`,

  wordPairs: {
    extend: "전하다",
    commitment: "헌신",
    outstanding: "뛰어난",
    unnoticed: "주목받지 않은",
  },

  questions: [],
};

const email11 = {
  id: 11,
  passage: `Subject: Appreciation for Your Valuable Partnership

Dear Mr. Richardson,

On behalf of our entire team, I would like to express our sincere appreciation for your continued partnership and support. Over the past year, your company has played a <mark>crucial</mark> role in helping us deliver high-quality products and services to our clients.

Your professionalism, <mark>reliability</mark>, and commitment to excellence have been truly <mark>commendable</mark>. We value this partnership and look forward to continued collaboration in the future.

Once again, thank you for your dedication and outstanding service. We look forward to many more successful projects together.

Best regards,
Michael Harris
Director of Operations`,

  translation: `제목: 귀중한 파트너십에 대한 감사

Richardson님께,

저희 전체 팀을 대표하여, 지속적인 파트너십과 지원에 대해 진심으로 감사드립니다. 지난 한 해 동안, 귀사는 저희가 고객들에게 고품질의 제품과 서비스를 제공하는 데 중요한 역할을 해주셨습니다.

귀사의 전문성, 신뢰성, 그리고 탁월함에 대한 헌신은 정말 칭찬할 만합니다. 저희는 이 파트너십을 소중히 여기며, 앞으로도 지속적인 협력을 기대합니다.

다시 한 번 귀사의 헌신과 뛰어난 서비스에 감사드립니다. 앞으로도 더 많은 성공적인 프로젝트를 함께 하기를 기대합니다.

감사합니다.
Michael Harris
운영 이사`,

  koreanNouns: `Subject: Appreciation for Your Valuable Partnership

Dear Mr. Richardson,

On behalf of our entire team, I would like to express our sincere appreciation for your continued partnership and support. Over the past year, your company has played a <mark>중요한</mark> role in helping us deliver high-quality products and services to our clients.

Your professionalism, <mark>신뢰성</mark>, and commitment to excellence have been truly <mark>칭찬할 만한</mark>. We value this partnership and look forward to continued collaboration in the future.

Once again, thank you for your dedication and outstanding service. We look forward to many more successful projects together.

Best regards,
Michael Harris
Director of Operations`,

  wordPairs: {
    crucial: "중요한",
    reliability: "신뢰성",
    commendable: "칭찬할 만한",
  },

  questions: [],
};

const email12 = {
  id: 12,
  passage: `Subject: Inquiry Regarding Service Agreement Terms

Dear Ms. Robertson,

I am reaching out to seek <mark>clarification</mark> regarding the terms <mark>outlined</mark> in the service agreement we received on March 5. Before proceeding with the contract, we would like to confirm a few details related to the payment schedule and service <mark>deliverables</mark>.

Could you please provide additional information on the following points?

The exact <mark>billing cycle</mark> and any applicable late fees.
The process for requesting modifications to <mark>service scope</mark> after the contract is signed.
We appreciate your assistance in this matter. Please let us know if we need to arrange a call to discuss these details further.

Looking forward to your response.

Best regards,
Daniel Foster
Procurement Manager`,

  translation: `제목: 서비스 계약 조건에 관한 문의

Robertson님께,

3월 5일에 받은 서비스 계약서에 명시된 조건들에 대해 명확히 하고자 연락드립니다. 계약을 진행하기 전에, 지불 일정과 서비스 제공 사항과 관련된 몇 가지 세부사항을 확인하고 싶습니다.

다음 사항들에 대해 추가 정보를 제공해 주시겠습니까?

정확한 청구 주기와 해당되는 연체료
계약 체결 후 서비스 범위 수정 요청 절차
이 건에 대한 귀하의 도움에 감사드립니다. 이러한 세부사항들을 더 논의하기 위해 통화 일정을 잡을 필요가 있다면 알려주시기 바랍니다.

답변을 기다리겠습니다.

감사합니다.
Daniel Foster
구매 관리자`,

  koreanNouns: `Subject: Inquiry Regarding Service Agreement Terms

Dear Ms. Robertson,

I am reaching out to seek <mark>설명</mark> regarding the terms <mark>명시된</mark> in the service agreement we received on March 5. Before proceeding with the contract, we would like to confirm a few details related to the payment schedule and service <mark>납품물</mark>.

Could you please provide additional information on the following points?

The exact <mark>청구 주기</mark> and any applicable late fees.
The process for requesting modifications to <mark>서비스 범위</mark> after the contract is signed.
We appreciate your assistance in this matter. Please let us know if we need to arrange a call to discuss these details further.

Looking forward to your response.

Best regards,
Daniel Foster
Procurement Manager`,

  wordPairs: {
    clarification: "설명",
    outlined: "명시된",
    deliverables: "납품물",
    "billing cycle": "청구 주기",
    "service scope": "서비스 범위",
  },

  questions: [],
};

const email13 = {
  id: 13,
  passage: `Subject: Business Proposal – Strategic Partnership Opportunity
Dear Mr. David Richardson,

I hope this email finds you well. I am reaching out <mark>on behalf of</mark> Horizon Solutions to propose a strategic partnership that would create <mark>mutual</mark> growth opportunities for both our organizations.

📌 Proposal Overview:
We have identified a strong alignment between Horizon Solutions and GreenTech Enterprises, particularly in the area of <mark>sustainable</mark> technology development. Our proposed collaboration would focus on:
✔ Joint product development to enhance eco-friendly solutions in the market
✔ Knowledge sharing through specialized training sessions and industry workshops
✔ Co-marketing initiatives to expand brand visibility and customer engagement

📌 Key Benefits:
✔ Increased Market Reach: Leverage both companies' networks to attract a <mark>broader</mark> client base
✔ Cost Efficiency: Reduce R&D expenses through shared resources and expertise
✔ Competitive Advantage: Combine technological expertise to deliver innovative solutions

📌 Next Steps:
To further discuss this opportunity, we would like to schedule a virtual meeting at your convenience. Please let us know your availability for a 30-minute discussion next week.

If you require additional details, I am happy to provide a detailed business plan outlining the scope and potential impact of this collaboration.

We look forward to the possibility of working together and hope to establish a long-term partnership that benefits both organizations. Please feel free to reach out with any questions.

Best regards,
Daniel Roberts
Business Development Manager
Horizon Solutions
📧 daniel.roberts@horizoncompany.com`,

  translation: `제목: 사업 제안 - 전략적 파트너십 기회
데이비드 리처드슨 님께,

안녕하십니까. 양사의 상호 성장 기회를 창출할 전략적 파트너십을 제안하고자 호라이즌 솔루션즈를 대표하여 연락드립니다.

📌 제안 개요:
호라이즌 솔루션즈와 그린테크 엔터프라이즈 간에 특히 지속 가능한 기술 개발 분야에서 강력한 연계성을 확인했습니다. 제안된 협력은 다음 사항에 중점을 둘 것입니다:
✔ 시장의 친환경 솔루션을 강화하기 위한 공동 제품 개발
✔ 전문 교육 세션과 산업 워크샵을 통한 지식 공유
✔ 브랜드 가시성과 고객 참여를 확대하기 위한 공동 마케팅 이니셔티브

📌 주요 이점:
✔ 시장 도달 범위 확대: 양사의 네트워크를 활용하여 더 넓은 고객층 유치
✔ 비용 효율성: 공유 자원과 전문성을 통한 R&D 비용 절감
✔ 경쟁 우위: 기술적 전문성을 결합하여 혁신적인 솔루션 제공

📌 다음 단계:
이 기회를 더 논의하기 위해 귀하의 편의에 맞춰 화상 회의를 예약하고자 합니다. 다음 주 30분 논의를 위한 귀하의 가능한 시간을 알려주시기 바랍니다.

추가 세부사항이 필요하시다면 이 협력의 범위와 잠재적 영향을 설명하는 상세한 사업 계획서를 제공해 드리겠습니다.

함께 일할 수 있는 가능성을 기대하며, 양 조직에 도움이 되는 장기적인 파트너십을 구축하기를 희망합니다. 문의사항이 있으시면 언제든 연락 주시기 바랍니다.

감사합니다.
대니얼 로버츠
사업개발 매니저
호라이즌 솔루션즈
📧 daniel.roberts@horizoncompany.com`,
  koreanNouns: `Subject: Business Proposal – Strategic Partnership Opportunity
Dear Mr. David Richardson,

I hope this email finds you well. I am reaching out <mark>대표하여</mark> Horizon Solutions to propose a strategic partnership that would create <mark>상호적인</mark> growth opportunities for both our organizations.

📌 Proposal Overview:
We have identified a strong alignment between Horizon Solutions and GreenTech Enterprises, particularly in the area of <mark>지속 가능한</mark> technology development. Our proposed collaboration would focus on:
✔ Joint product development to enhance eco-friendly solutions in the market
✔ Knowledge sharing through specialized training sessions and industry workshops
✔ Co-marketing initiatives to expand brand visibility and customer engagement

📌 Key Benefits:
✔ Increased Market Reach: Leverage both companies' networks to attract a <mark>더 넓은</mark> client base
✔ Cost Efficiency: Reduce R&D expenses through shared resources and expertise
✔ Competitive Advantage: Combine technological expertise to deliver innovative solutions

📌 Next Steps:
To further discuss this opportunity, we would like to schedule a virtual meeting at your convenience. Please let us know your availability for a 30-minute discussion next week.

If you require additional details, I am happy to provide a detailed business plan outlining the scope and potential impact of this collaboration.

We look forward to the possibility of working together and hope to establish a long-term partnership that benefits both organizations. Please feel free to reach out with any questions.

Best regards,
Daniel Roberts
Business Development Manager
Horizon Solutions
📧 daniel.roberts@horizoncompany.com`,
  wordPairs: {
    "on behalf of": "대표하여",
    mutual: "상호적인",
    sustainable: "지속 가능한",
    broader: "더 넓은",
  },

  questions: [],
};
const email14 = {
  id: 14,
  passage: `Subject: Letter of Recommendation for Emily J. Carter

TechForward Enterprises
5678 Corporate Way
New York, NY 10202

Dear Ms. Davis,

I am writing to offer my <mark>enthusiastic</mark> recommendation for Emily J. Carter, who worked with us at BrightWave Digital for the past four years as a Digital Marketing Specialist. It has been a <mark>privilege</mark> to work closely with Emily during this time, and I do not doubt that she will be an outstanding addition to your team.

During her time with us, Emily was instrumental in launching several key marketing campaigns, all of which exceeded our performance targets. Her creativity, analytical skills, and attention to detail were evident in every project. One particular campaign, which focused on expanding our brand presence on social media platforms, saw a 45% increase in engagement and a 30% growth in sales within the first quarter of its launch. Emily's ability to think outside the box while remaining data-driven made her an invaluable asset to our department.

What truly <mark>sets</mark> Emily <mark>apart</mark> is her ability to collaborate effectively with cross-functional teams. She was consistently <mark>praised</mark> by colleagues for her positive attitude, leadership, and <mark>willingness</mark> to mentor junior team members. Her communication skills, both written and <mark>verbal</mark>, are exceptional, and she has a natural ability to present complex ideas in an <mark>accessible</mark> and <mark>engaging</mark> manner.

Emily is a dedicated <mark>professional</mark> with a strong work ethic and a passion for digital marketing. I am confident that she will bring the same level of enthusiasm and <mark>expertise</mark> to any role she takes on. I <mark>wholeheartedly</mark> recommend her for the position at TechForward Enterprises and am confident that she will make a significant impact within your organization.

If you have any further questions, please feel free to contact me at jonathan.lee@brightwavedigital.com.

Sincerely,
Jonathan Lee
Senior Marketing Manager
BrightWave Digital`,
  translation: `제목: Emily J. Carter에 대한 추천서

TechForward Enterprises
5678 Corporate Way
New York, NY 10202

Davis 님께,

BrightWave Digital에서 지난 4년간 디지털 마케팅 전문가로 근무한 Emily J. Carter를 열정적으로 추천하고자 이 글을 씁니다. 이 기간 동안 Emily와 긴밀히 일할 수 있었던 것은 특권이었으며, 그녀가 귀사 팀에 탁월한 인재가 될 것이라는 점을 의심치 않습니다.

저희와 함께한 기간 동안, Emily는 여러 주요 마케팅 캠페인을 시작하는 데 중추적인 역할을 했으며, 모든 캠페인은 성과 목표를 초과 달성했습니다. 그녀의 창의성, 분석 능력, 세부 사항에 대한 주의력은 모든 프로젝트에서 분명히 드러났습니다. 특히 소셜 미디어 플랫폼에서 브랜드 존재감을 확장하는 데 초점을 맞춘 한 캠페인은 출시 첫 분기 내에 참여도가 45% 증가하고 판매가 30% 성장했습니다. Emily가 데이터 중심적인 접근을 유지하면서도 틀에 얽매이지 않는 사고 능력은 우리 부서에 매우 귀중한 자산이었습니다.

Emily를 진정으로 돋보이게 하는 것은 다양한 기능의 팀과 효과적으로 협업하는 능력입니다. 그녀는 긍정적인 태도, 리더십, 주니어 팀원들을 멘토링하려는 의지로 동료들로부터 지속적으로 칭찬을 받았습니다. 그녀의 서면 및 구두 의사소통 능력은 탁월하며, 복잡한 아이디어를 접근하기 쉽고 매력적인 방식으로 제시하는 타고난 능력을 가지고 있습니다.

Emily는 강한 직업 윤리와 디지털 마케팅에 대한 열정을 가진 헌신적인 전문가입니다. 그녀가 맡게 될 어떤 역할에도 같은 수준의 열정과 전문성을 가져올 것이라고 확신합니다. TechForward Enterprises의 직책에 그녀를 전적으로 추천하며, 그녀가 귀사 조직 내에서 중요한 영향을 미칠 것이라고 확신합니다.

추가 질문이 있으시면 jonathan.lee@brightwavedigital.com으로 언제든지 연락해 주십시오.

감사합니다,
Jonathan Lee
수석 마케팅 매니저
BrightWave Digital`,
  koreanNouns: `Subject: Letter of Recommendation for Emily J. Carter

TechForward Enterprises
5678 Corporate Way
New York, NY 10202

Dear Ms. Davis,

I am writing to offer my <mark>열정적으로</mark> recommendation for Emily J. Carter, who worked with us at BrightWave Digital for the past four years as a Digital Marketing Specialist. It has been a <mark>특권</mark> to work closely with Emily during this time, and I do not doubt that she will be an outstanding addition to your team.

During her time with us, Emily was instrumental in launching several key marketing campaigns, all of which exceeded our performance targets. Her creativity, analytical skills, and attention to detail were evident in every project. One particular campaign, which focused on expanding our brand presence on social media platforms, saw a 45% increase in engagement and a 30% growth in sales within the first quarter of its launch. Emily's ability to think outside the box while remaining data-driven made her an invaluable asset to our department.

What truly <mark>두다</mark> Emily <mark>따로(구별되게)</mark> is her ability to collaborate effectively with cross-functional teams. She was consistently <mark>칭찬을 받았다</mark> by colleagues for her positive attitude, leadership, and <mark>의지</mark> to mentor junior team members. Her communication skills, both written and <mark>구두로</mark>, are exceptional, and she has a natural ability to present complex ideas in an <mark>이해하기 쉬운</mark> and <mark>흥미로운</mark> manner.

Emily is a dedicated <mark>전문가</mark> with a strong work ethic and a passion for digital marketing. I am confident that she will bring the same level of enthusiasm and <mark>전문성</mark> to any role she takes on. I <mark>전적으로</mark> recommend her for the position at TechForward Enterprises and am confident that she will make a significant impact within your organization.

If you have any further questions, please feel free to contact me at jonathan.lee@brightwavedigital.com.

Sincerely,
Jonathan Lee
Senior Marketing Manager
BrightWave Digital`,
  wordPairs: {
    enthusiastic: "열정적으로",
    privilege: "특권",
    sets: "두다",
    apart: "따로(구별되게)",
    praised: "칭찬을 받았다",
    willingness: "의지",
    verbal: "구두로",
    accessible: "이해하기 쉬운",
    engaging: "흥미로운",
    professional: "전문가",
    expertise: "전문성",
    wholeheartedly: "전적으로",
  },
  questions: [],
};
const email15 = {
  id: 15,
  passage: `Subject: Celebrating: 100,000 Happy Customers!

Dear Learnify Hub Team,

Exciting news! We've hit a major milestone: 100,000 happy customers! This achievement <mark>reflects</mark> your hard work, <mark>dedication</mark>, and passion. From <mark>frontline</mark> to behind-the-scenes, each of you has played a <mark>vital</mark> role in reaching this milestone. Your commitment to excellence and customer satisfaction has been <mark>outstanding</mark>.

As we celebrate, let's remember what this milestone <mark>signifies</mark>: our pursuit of excellence, dedication to customer happiness, and commitment to delivering exceptional experiences. While reaching 100,000 customers is huge, it's just the beginning. Let's keep innovating and collaborating to <mark>surpass</mark> expectations and set new standards.

Thank you for your <mark>unwavering</mark> dedication. I'm proud to be part of this team and excited for our future successes. Congratulations to all on this <mark>incredible</mark> achievement! Let's keep celebrating, learning, and pushing <mark>boundaries</mark> together.

Best regards,
Rachel Kim
Head of Marketing
Learnify Hub`,

  translation: `제목: 축하합니다: 100,000명의 행복한 고객들!

Learnify Hub 팀에게,

흥미로운 소식입니다! 우리는 중요한 이정표에 도달했습니다: 100,000명의 행복한 고객들! 이 성과는 여러분의 열심히 일한 노력, 헌신, 그리고 열정을 반영합니다. 최전선에서부터 무대 뒤에서 일하는 모든 분들까지, 여러분 각자가 이 이정표에 도달하는 데 중요한 역할을 했습니다. 탁월함과 고객 만족에 대한 여러분의 헌신은 뛰어났습니다.

우리가 축하하는 동안, 이 이정표가 의미하는 바를 기억합시다: 탁월함을 추구하고, 고객 행복에 헌신하며, 탁월한 경험을 제공하기 위한 약속입니다. 100,000명의 고객에 도달한 것은 엄청난 일이지만, 이것은 단지 시작일 뿐입니다. 계속해서 혁신하고 협력하여 기대를 뛰어넘고 새로운 기준을 세워 나갑시다.

여러분의 흔들림 없는 헌신에 감사드립니다. 저는 이 팀의 일원이 된 것을 자랑스럽게 생각하며 우리의 미래 성공에 대해 기대하고 있습니다. 이 놀라운 성과에 대해 모두에게 축하드립니다! 함께 계속 축하하고, 배우고, 경계를 넓혀 나갑시다.

감사합니다,
Rachel Kim
마케팅 책임자
Learnify Hub`,
  koreanNouns: `Subject: Celebrating: 100,000 Happy Customers!

Dear Learnify Hub Team,

Exciting news! We've hit a major milestone: 100,000 happy customers! This achievement <mark>반영하다</mark> your hard work, <mark>헌신</mark>, and passion. From <mark>최전선</mark> to behind-the-scenes, each of you has played a <mark>중요한</mark> role in reaching this milestone. Your commitment to excellence and customer satisfaction has been <mark>뛰어난</mark>.

As we celebrate, let's remember what this milestone <mark>의미하다</mark>: our pursuit of excellence, dedication to customer happiness, and commitment to delivering exceptional experiences. While reaching 100,000 customers is huge, it's just the beginning. Let's keep innovating and collaborating to <mark>뛰어넘다</mark> expectations and set new standards.

Thank you for your <mark>흔들림 없는</mark> dedication. I'm proud to be part of this team and excited for our future successes. Congratulations to all on this <mark>놀라운</mark> achievement! Let's keep celebrating, learning, and pushing <mark>경계</mark> together.

Best regards,
Rachel Kim
Head of Marketing
Learnify Hub`,

  wordPairs: {
    reflects: "반영하다",
    dedication: "헌신",
    frontline: "최전선",
    vital: "중요한",
    outstanding: "뛰어난",
    signifies: "의미하다",
    surpass: "뛰어넘다",
    unwavering: "흔들림 없는",
    incredible: "놀라운",
    boundaries: "경계",
  },

  questions: [],
};

const email16 = {
  id: 16,
  passage: `Subject: Business Proposal for Collaboration

Dear Mr. Renner,

I hope this email finds you well.

My name is Daniel Park, and I represent Nexora Tech, a leading organization in the technology sector. I am reaching out to you today to discuss a potential collaboration that could be <mark>mutually</mark> beneficial for both our organizations. At Nexora Tech, we are always exploring new opportunities to expand our operations and <mark>foster</mark> partnerships that align with our strategic goals.

We have been following MultiCorp's recent achievements and believe that working together could open up new avenues for innovation and growth. Specifically, we are interested in exploring potential synergies in software development and data security. I believe that your <mark>expertise</mark> in digital solutions, combined with our advanced research and development capabilities, would create a strong foundation for future projects.

To initiate this discussion, I would like to propose a meeting at your earliest convenience. Please let me know a <mark>suitable</mark> time and date that works for you, and I will be happy to <mark>accommodate</mark>. You may contact me directly <mark>via</mark> this email or at (212) 555-7842 to arrange further details.

Thank you for considering this opportunity. I look forward to the possibility of working together and developing a successful partnership.

Warm regards,
Daniel Park
Chief Executive Officer
Nexora Tech`,

  translation: `제목: 협업을 위한 비즈니스 제안

Renner님께,

안녕하세요.

저는 Daniel Park이며, 기술 분야의 선도적인 조직인 Nexora Tech를 대표하고 있습니다. 오늘 저는 우리 두 조직 모두에게 상호 이익이 될 수 있는 잠재적 협업에 대해 논의하고자 연락드립니다. Nexora Tech에서는 항상 우리의 운영을 확장하고 전략적 목표에 부합하는 파트너십을 육성할 새로운 기회를 모색하고 있습니다.

저희는 MultiCorp의 최근 성과를 지켜보았으며, 함께 일하는 것이 혁신과 성장을 위한 새로운 길을 열 수 있다고 믿습니다. 특히, 저희는 소프트웨어 개발 및 데이터 보안 분야에서 잠재적 시너지를 탐색하는 데 관심이 있습니다. 귀사의 디지털 솔루션 전문성과 저희의 고급 연구 개발 능력을 결합하면 미래 프로젝트를 위한 강력한 기반이 될 것이라고 생각합니다.

이 논의를 시작하기 위해, 가능한 빠른 시일 내에 미팅을 제안하고 싶습니다. 귀하께 적합한 시간과 날짜를 알려주시면, 기꺼이 맞추도록 하겠습니다. 이 이메일이나 (212) 555-7842로 직접 연락하셔서 추가 세부 사항을 조정하실 수 있습니다.

이 기회를 고려해 주셔서 감사합니다. 함께 일하고 성공적인 파트너십을 발전시킬 가능성을 기대합니다.

감사합니다,
Daniel Park
최고 경영자
Nexora Tech`,

  koreanNouns: `Subject: Business Proposal for Collaboration

  Dear Mr. Renner,
  
  I hope this email finds you well.
  
  My name is Daniel Park, and I represent Nexora Tech, a leading organization in the technology sector. I am reaching out to you today to discuss a potential collaboration that could be <mark>상호적으로</mark> beneficial for both our organizations. At Nexora Tech, we are always exploring new opportunities to expand our operations and <mark>육성하다</mark> partnerships that align with our strategic goals.
  
  We have been following MultiCorp's recent achievements and believe that working together could open up new avenues for innovation and growth. Specifically, we are interested in exploring potential synergies in software development and data security. I believe that your <mark>전문성</mark> in digital solutions, combined with our advanced research and development capabilities, would create a strong foundation for future projects.
  
  To initiate this discussion, I would like to propose a meeting at your earliest convenience. Please let me know a <mark>적합한</mark> time and date that works for you, and I will be happy to <mark>맞추다</mark>. You may contact me directly <mark>통해</mark> this email or at (212) 555-7842 to arrange further details.
  
  Thank you for considering this opportunity. I look forward to the possibility of working together and developing a successful partnership.
  
  Warm regards,
  Daniel Park
  Chief Executive Officer
  Nexora Tech`,

  wordPairs: {
    mutually: "상호적으로",
    foster: "육성하다",
    expertise: "전문성",
    suitable: "적합한",
    accommodate: "맞추다",
    via: "통해",
  },

  questions: [],
};
const email17 = {
  id: 17,
  passage: `Subject: Proposal for Collaboration on Upcoming Project

Dear Mr. York,

I hope this email finds you well. My name is Angela Kim, and I am writing <mark>on behalf of</mark> EcoNova Solutions. I am reaching out to explore the possibility of collaborating on an upcoming project that <mark>aligns with</mark> your expertise and our current objectives.

At EcoNova Solutions, we are <mark>constantly</mark> seeking innovative solutions and partnerships that can drive growth and success for both parties involved. Your organization's reputation for excellence and innovation makes you an ideal partner for this initiative. We believe that a collaborative effort could lead to <mark>mutual</mark> benefits and significant accomplishments.

Project Overview:
We are planning a project set to launch in early 2055, focused on sustainable technology development for urban environments. This initiative aims to <mark>revolutionize</mark> the efficiency of city infrastructure through green energy solutions and smart systems. Based on your recent achievements in environmental engineering and urban planning, we believe your involvement would be instrumental in ensuring its success.

Key Benefits of Collaboration:
- Shared expertise and resources to drive project goals
- Potential for expanding <mark>market reach</mark> and increasing visibility
- Access to a wider network of industry professionals and clients

We would appreciate the opportunity to discuss this further and explore how we can work together to achieve these goals. Please let us know if you would be available for a meeting at your earliest convenience. I am happy to accommodate a time that suits your schedule.

Thank you for considering this potential collaboration. I look forward to your response and hope to establish a productive partnership.

Warm regards,
Angela Kim
Director of Strategic Partnerships
EcoNova Solutions
(212) 555-3492`,

  translation: `제목: 다가오는 프로젝트에 대한 협업 제안

York님께,

안녕하세요. 저는 EcoNova Solutions의 Angela Kim입니다. 귀하의 전문성과 저희의 현재 목표에 부합하는 다가오는 프로젝트에 대한 협업 가능성을 모색하고자 연락드립니다.

EcoNova Solutions에서는 양측 모두에게 성장과 성공을 가져올 수 있는 혁신적인 솔루션과 파트너십을 지속적으로 추구하고 있습니다. 귀사의 우수성과 혁신에 대한 명성은 이 이니셔티브에 이상적인 파트너가 됩니다. 협력적인 노력이 상호 이익과 중요한 성과로 이어질 수 있다고 믿습니다.

프로젝트 개요:
저희는 2055년 초에 출시될 예정인 도시 환경을 위한 지속 가능한 기술 개발에 중점을 둔 프로젝트를 계획하고 있습니다. 이 이니셔티브는 친환경 에너지 솔루션과 스마트 시스템을 통해 도시 인프라의 효율성을 혁신하는 것을 목표로 합니다. 환경 공학 및 도시 계획 분야에서의 귀사의 최근 성과를 바탕으로, 귀사의 참여가 성공을 보장하는 데 중요한 역할을 할 것이라고 믿습니다.

협업의 주요 이점:

프로젝트 목표를 추진하기 위한 공유된 전문 지식과 자원

시장 도달 범위를 확장하고 가시성을 높일 수 있는 잠재력

더 넓은 업계 전문가 및 고객 네트워크에 대한 접근

이에 대해 더 논의하고 이러한 목표를 달성하기 위해 어떻게 함께 일할 수 있는지 탐색할 기회를 갖고 싶습니다. 가능한 빠른 시일 내에 미팅이 가능하신지 알려주시기 바랍니다. 귀하의 일정에 맞는 시간을 기꺼이 맞추겠습니다.

이 잠재적 협업을 고려해 주셔서 감사합니다. 귀하의 답변을 기다리며 생산적인 파트너십을 구축할 수 있기를 바랍니다.

감사합니다,
Angela Kim
전략적 파트너십 이사
EcoNova Solutions
(212) 555-3492`,

  koreanNouns: `Subject: Proposal for Collaboration on Upcoming Project

Dear Mr. York,

I hope this email finds you well. My name is Angela Kim, and I am writing <mark>대신하여 -을</mark> EcoNova Solutions. I am reaching out to explore the possibility of collaborating on an upcoming project that <mark>부합하다 - 와</mark> your expertise and our current objectives.

At EcoNova Solutions, we are <mark>지속적으로</mark> seeking innovative solutions and partnerships that can drive growth and success for both parties involved. Your organization's reputation for excellence and innovation makes you an ideal partner for this initiative. We believe that a collaborative effort could lead to <mark>상호</mark> benefits and significant accomplishments.

Project Overview:
We are planning a project set to launch in early 2055, focused on sustainable technology development for urban environments. This initiative aims to <mark>혁신하다</mark> the efficiency of city infrastructure through green energy solutions and smart systems. Based on your recent achievements in environmental engineering and urban planning, we believe your involvement would be instrumental in ensuring its success.

Key Benefits of Collaboration:
- Shared expertise and resources to drive project goals
- Potential for expanding <mark>시장 도달 범위</mark> and increasing visibility
- Access to a wider network of industry professionals and clients

We would appreciate the opportunity to discuss this further and explore how we can work together to achieve these goals. Please let us know if you would be available for a meeting at your earliest convenience. I am happy to accommodate a time that suits your schedule.

Thank you for considering this potential collaboration. I look forward to your response and hope to establish a productive partnership.

Warm regards,
Angela Kim
Director of Strategic Partnerships
EcoNova Solutions
(212) 555-3492`,

  wordPairs: {
    "on behalf of": "대신하여 -을",
    "aligns with": "부합하다 - 와",
    constantly: "지속적으로",
    mutual: "상호",
    revolutionize: "혁신하다",
    "market reach": "시장 도달 범위",
  },

  questions: [],
};

const email18 = {
  id: 18,
  passage: `Subject: Exclusive Offer for Our Valued Customer

Dear Mr. Walker,

We at ZenLux Corporation are excited to present to you our <mark>latest</mark> product. Built with innovation and precision, we're confident this product is a game-changer a truly. As a valued customer, we're offering you a limited-time offer, available exclusively for existing <mark>patrons</mark>. A 20% discount on your very first purchase of our latest product.

We believe this product can <mark>seamlessly</mark> <mark>integrate</mark> into your operations and potentially enhance productivity. Your business goals align with our product's potential, and this promotion is the perfect opportunity for you to explore this beneficial synergy.

This promotion is valid only until February 15, 2050. Act fast and seize this wonderful opportunity to elevate your business to new heights. We appreciate your continued trust in our products and services. Thank you for your time, and we hope to continue <mark>nourishing</mark> this rewarding business relationship.

Best Regards,

Juwan Greenholt
ZenLux Corporation`,

  translation: `제목: 소중한 고객님을 위한 독점 제안

Walker 님께,

저희 ZenLux Corporation은 최신 제품을 소개해 드리게 되어 기쁩니다. 혁신과 정밀함으로 제작된 이 제품은 진정한 게임 체인저라고 확신합니다. 소중한 고객님으로서, 기존 고객님들만을 위한 한정 시간 제안을 드립니다. 저희 최신 제품 첫 구매 시 20% 할인 혜택을 받으실 수 있습니다.

이 제품이 귀하의 운영에 원활하게 통합되어 생산성을 향상시킬 수 있다고 믿습니다. 귀하의 비즈니스 목표는 저희 제품의 잠재력과 일치하며, 이번 프로모션은 이러한 유익한 시너지를 탐색할 수 있는 완벽한 기회입니다.

이 프로모션은 2050년 2월 15일까지만 유효합니다. 서둘러 귀하의 비즈니스를 새로운 높이로 끌어올릴 수 있는 이 멋진 기회를 잡으세요. 저희 제품과 서비스에 대한 지속적인 신뢰에 감사드립니다. 시간을 내주셔서 감사하며, 이 보람찬 비즈니스 관계를 계속해서 발전시켜 나가기를 바랍니다.

감사합니다,

Juwan Greenholt
ZenLux Corporation`,

  koreanNouns: `Subject: Exclusive Offer for Our Valued Customer

Dear Mr. Walker,

We at ZenLux Corporation are excited to present to you our <mark>최신의</mark> product. Built with innovation and precision, we're confident this product is a game-changer a truly. As a valued customer, we're offering you a limited-time offer, available exclusively for existing <mark>고객, 후원자</mark>. A 20% discount on your very first purchase of our latest product.

We believe this product can <mark>원활하게, 매끄럽게</mark> <mark>통합하다</mark> into your operations and potentially enhance productivity. Your business goals align with our product's potential, and this promotion is the perfect opportunity for you to explore this beneficial synergy.

This promotion is valid only until February 15, 2050. Act fast and seize this wonderful opportunity to elevate your business to new heights. We appreciate your continued trust in our products and services. Thank you for your time, and we hope to continue <mark>발전시키다, 육성하다</mark> this rewarding business relationship.

Best Regards,

Juwan Greenholt
ZenLux Corporation`,
  wordPairs: {
    latest: "최신의",
    patrons: "고객, 후원자",
    seamlessly: "원활하게, 매끄럽게",
    integrate: "통합하다",
    nourishing: "발전시키다, 육성하다",
  },

  questions: [],
};

const email19 = {
  id: 19,
  passage: `Subject: Introduction of NovaEdge Solutions' New Product

Mr. Daniel Roberts
4128 Park Avenue
Chicago, IL 60601

Dear Mr. Roberts,

I hope this letter finds you in good health. I am writing this letter to introduce our newly launched product from NovaEdge Solutions, the Mi-52 solution—an innovative solution designed to address the challenges of the contemporary digitized world.

The Mi-52 is a product crafted for excellence, with advanced features to <mark>aid</mark> in seamless operations, providing holistic solutions for better productivity and performance. We believe that this breakthrough product could be a game-changer for your business by significantly improving efficiency and streamlining operations.

We are <mark>eagerly</mark> looking forward to the opportunity to present this product to you in detail and <mark>illustrate</mark> its prospective benefits for your company. Our representative will be more than happy to provide further information upon your request. Kindly let us know about a suitable time to further discuss this opportunity.

Thank you for your time and consideration. We hope to hear from you soon.

Best Regards,
Samantha Lee
Marketing Manager`,

  translation: `제목: NovaEdge Solutions의 신제품 소개

Daniel Roberts 님
4128 Park Avenue
Chicago, IL 60601

Roberts 님께,

이 편지가 귀하의 건강한 모습에 전달되기를 바랍니다. 저는 NovaEdge Solutions에서 새롭게 출시한 제품인 Mi-52 솔루션—현대 디지털화된 세계의 도전과제를 해결하기 위해 설계된 혁신적인 솔루션을 소개하고자 이 편지를 씁니다.

Mi-52는 원활한 운영을 돕는 고급 기능을 갖춘 우수성을 위해 제작된 제품으로, 더 나은 생산성과 성능을 위한 총체적인 솔루션을 제공합니다. 이 획기적인 제품이 효율성을 크게 향상시키고 운영을 간소화함으로써 귀하의 비즈니스에 게임 체인저가 될 수 있다고 믿습니다.

이 제품을 자세히 소개하고 귀사에 대한 잠재적 이점을 설명할 기회를 간절히 기대하고 있습니다. 저희 담당자가 요청 시 추가 정보를 제공해 드리겠습니다. 이 기회에 대해 더 논의할 수 있는 적절한 시간을 알려주시기 바랍니다.

시간과 고려에 감사드립니다. 곧 소식을 듣기를 바랍니다.

감사합니다,
Samantha Lee
마케팅 매니저`,

  koreanNouns: `Subject: Introduction of NovaEdge Solutions' New Product

Mr. Daniel Roberts
4128 Park Avenue
Chicago, IL 60601

Dear Mr. Roberts,

I hope this letter finds you in good health. I am writing this letter to introduce our newly launched product from NovaEdge Solutions, the Mi-52 solution—an innovative solution designed to address the challenges of the contemporary digitized world.

The Mi-52 is a product crafted for excellence, with advanced features to <mark>돕다, 지원하다</mark> in seamless operations, providing holistic solutions for better productivity and performance. We believe that this breakthrough product could be a game-changer for your business by significantly improving efficiency and streamlining operations.

We are <mark>간절히, 열렬히</mark> looking forward to the opportunity to present this product to you in detail and <mark>설명하다, 보여주다</mark> its prospective benefits for your company. Our representative will be more than happy to provide further information upon your request. Kindly let us know about a suitable time to further discuss this opportunity.

Thank you for your time and consideration. We hope to hear from you soon.

Best Regards,
Samantha Lee
Marketing Manager`,

  wordPairs: {
    aid: "돕다, 지원하다",
    eagerly: "간절히, 열렬히",
    illustrate: "설명하다, 보여주다",
  },

  questions: [],
};

const email20 = {
  id: 20,
  passage: `December 12, 2058

Ms. Olivia Bennett
Aurora <mark>Retail</mark> Group
1987 Crestview Blvd
Los Angeles, CA 90001

Dear Ms. Bennett,

I hope this letter finds you well. My name is Jason Choi, and I am representing NovaEdge Marketing. We bring to your attention our latest marketing strategies in <mark>retail</mark>, which are targeted as per our customer's <mark>preferences</mark> for a more personalized shopping experience.

Our plan combines our understanding of market trends with cutting-edge technology. This unique blend enables NovaEdge Marketing to deliver a more engaging and <mark>relevant</mark> product promotion strategy. We believe this is the way forward in <mark>retail</mark>, and we are excited about the potential benefits for your business.

I would appreciate the opportunity to further discuss our innovative marketing strategies with you. We could then <mark>tailor</mark> those strategies to your specific needs and objectives, helping your business maximize sales and customer satisfaction.

Looking forward to your response. Should you require any immediate <mark>clarifications</mark>, please feel free to reply to this email.

Best regards,
Jason Choi`,

  translation: `2058년 12월 12일

Olivia Bennett 님
Aurora Retail Group
1987 Crestview Blvd
Los Angeles, CA 90001

Bennett 님께,

안녕하십니까. 저는 NovaEdge Marketing의 Jason Choi입니다. 저희는 고객의 선호도에 맞춘 더욱 개인화된 쇼핑 경험을 위한 최신 소매 마케팅 전략을 귀하께 소개해 드립니다.

저희 계획은 시장 동향에 대한 이해와 최첨단 기술을 결합합니다. 이러한 독특한 조합을 통해 NovaEdge Marketing은 더욱 매력적이고 관련성 높은 제품 홍보 전략을 제공할 수 있습니다. 저희는 이것이 소매업의 미래라고 믿으며, 귀사에 가져올 잠재적 이점에 대해 기대하고 있습니다.

저희의 혁신적인 마케팅 전략에 대해 더 자세히 논의할 기회를 갖게 되길 바랍니다. 그렇게 되면 귀사의 특정 요구와 목표에 맞게 전략을 조정하여 비즈니스의 매출과 고객 만족도를 극대화하는 데 도움을 드릴 수 있습니다.

귀하의 답변을 기다리겠습니다. 즉각적인 설명이 필요하시면 언제든지 이 이메일로 회신해 주십시오.

감사합니다,
Jason Choi`,
  koreanNouns: `December 12, 2058

  Ms. Olivia Bennett
  Aurora <mark>소매업</mark> Group
  1987 Crestview Blvd
  Los Angeles, CA 90001
  
  Dear Ms. Bennett,
  
  I hope this letter finds you well. My name is Jason Choi, and I am representing NovaEdge Marketing. We bring to your attention our latest marketing strategies in <mark>소매업</mark>, which are targeted as per our customer's <mark>선호도</mark> for a more personalized shopping experience.
  
  Our plan combines our understanding of market trends with cutting-edge technology. This unique blend enables NovaEdge Marketing to deliver a more engaging and <mark>관련성 있는</mark> product promotion strategy. We believe this is the way forward in <mark>소매업</mark>, and we are excited about the potential benefits for your business.
  
  I would appreciate the opportunity to further discuss our innovative marketing strategies with you. We could then <mark>맞추다</mark> those strategies to your specific needs and objectives, helping your business maximize sales and customer satisfaction.
  
  Looking forward to your response. Should you require any immediate <mark>설명</mark>, please feel free to reply to this email.
  
  Best regards,
  Jason Choi`,
  wordPairs: {
    retail: "소매업",
    relevant: "관련성 있는",
    preferences: "선호도",
    tailor: "맞추다",
    clarifications: "설명",
  },

  questions: [],
};
const email21 = {
  id: 21,
  passage: `November 2, 2054

Alphonso Farrell
2463 Ashton Lane,
Austin, TX 78704

Dear Mr. Farrell,

We hope this letter finds you in good health and spirits. The purpose of writing this letter is to introduce you to Culinary Canvas's upcoming promotional offer. Our restaurant takes great pride in serving <mark>eclectic</mark> cuisines prepared with love and <mark>precision</mark> by our world-class chefs. We believe that food is not just a matter of survival, but an art that brings joy and satisfaction.

As a well-<mark>regarded</mark> member of the community, we want to extend an exclusive dining offer to you. To express our appreciation for loyal patrons such as yourself, we have created a special promotion of 50% off on all items on Mondays. We trust this promotion will provide an excellent opportunity to enjoy your favorite dishes at a lower price or to explore our menu further.

To avail of this offer, just present this letter during your visit. Looking forward to welcoming you soon at Culinary Canvas and providing you with an unforgettable dining experience.

Kind regards,
Enrico Kessler`,

  translation: `2054년 11월 2일

Alphonso Farrell 님
2463 Ashton Lane,
Austin, TX 78704

Farrell 님께,

안녕하십니까, 귀하의 건강과 행복을 기원합니다. 이 편지를 쓰는 목적은 Culinary Canvas의 다가오는 프로모션 제안을 소개해 드리기 위함입니다. 저희 레스토랑은 세계적인 수준의 셰프들이 사랑과 정확성으로 준비한 다양한 요리를 제공하는 것에 큰 자부심을 가지고 있습니다. 저희는 음식이 단순히 생존의 문제가 아니라 기쁨과 만족을 가져다주는 예술이라고 믿습니다.

지역 사회의 존경받는 구성원으로서, 저희는 귀하께 독점적인 식사 제안을 드리고자 합니다. 귀하와 같은 충성스러운 고객에 대한 감사의 표시로, 월요일에 모든 메뉴 항목에 대해 50% 할인하는 특별 프로모션을 마련했습니다. 이 프로모션이 귀하가 좋아하는 요리를 더 저렴한 가격에 즐기거나 저희 메뉴를 더 탐색할 수 있는 좋은 기회가 될 것이라고 믿습니다.

이 혜택을 받으시려면, 방문 시 이 편지를 제시하시기만 하면 됩니다. Culinary Canvas에서 귀하를 곧 맞이하여 잊지 못할 식사 경험을 제공해 드리기를 기대합니다.

감사합니다,
Enrico Kessler`,

  koreanNouns: `November 2, 2054

Alphonso Farrell
2463 Ashton Lane,
Austin, TX 78704

Dear Mr. Farrell,

We hope this letter finds you in good health and spirits. The purpose of writing this letter is to introduce you to Culinary Canvas's upcoming promotional offer. Our restaurant takes great pride in serving <mark>다양한</mark> cuisines prepared with love and <mark>정확성</mark> by our world-class chefs. We believe that food is not just a matter of survival, but an art that brings joy and satisfaction.

As a well-<mark>존경받는</mark> member of the community, we want to extend an exclusive dining offer to you. To express our appreciation for loyal patrons such as yourself, we have created a special promotion of 50% off on all items on Mondays. We trust this promotion will provide an excellent opportunity to enjoy your favorite dishes at a lower price or to explore our menu further.

To avail of this offer, just present this letter during your visit. Looking forward to welcoming you soon at Culinary Canvas and providing you with an unforgettable dining experience.

Kind regards,
Enrico Kessler`,

  wordPairs: {
    eclectic: "다양한",
    precision: "정확성",
    regarded: "존경받는",
  },

  questions: [],
};

const email22 = {
  id: 22,
  passage: `November 28, 2052

George Thompson
707 Maple Road, Apt 8B
Lakeside, CA 90235

Dear Mr. Thompson, 

I am thrilled to introduce our latest product, QuantumEase Pro, to you. Our team has been working <mark>tirelessly</mark> over the past few months to develop QuantumEase Pro, which we believe will revolutionize the ergonomic furniture industry. QuantumEase Pro will provide you with <mark>a range of</mark> unique features designed to make your workspace solutions a <mark>breeze</mark>.

To celebrate QuantumEase Pro's launch, we offer an exclusive introductory promotion for early adopters. For the first month of release, we are offering a 15% discount off the regular price of QuantumEase Pro. This is a limited-time offer, so don't miss this opportunity to start benefiting from QuantumEase Pro.

Please do not hesitate to get in touch if you have any questions or want to order QuantumEase Pro. Remember, the discount is only available for a limited time, so act quickly to ensure you don't miss out.

Sincerely, 

Gary Jackson
Sales Manager
Quantum Solutions`,

  translation: `2052년 11월 28일

George Thompson
707 Maple Road, Apt 8B
Lakeside, CA 90235

Thompson 님께,

저희의 최신 제품인 QuantumEase Pro를 소개해 드리게 되어 기쁩니다. 저희 팀은 지난 몇 달 동안 QuantumEase Pro를 개발하기 위해 쉬지 않고 노력해 왔으며, 이 제품이 인체공학적 가구 산업에 혁명을 일으킬 것이라고 믿습니다. QuantumEase Pro는 귀하의 작업 공간 솔루션을 쉽게 만들어 줄 다양한 독특한 기능을 제공할 것입니다.

QuantumEase Pro의 출시를 기념하여, 얼리 어답터들을 위한 독점적인 소개 프로모션을 제공합니다. 출시 첫 달 동안, QuantumEase Pro의 정가에서 15% 할인을 제공하고 있습니다. 이는 한정된 시간 동안만 제공되는 혜택이므로, QuantumEase Pro의 혜택을 누리기 시작할 이 기회를 놓치지 마세요.

질문이 있거나 QuantumEase Pro를 주문하고 싶으시면 언제든지 연락 주시기 바랍니다. 할인은 한정된 시간 동안만 제공되므로, 놓치지 않도록 빠르게 행동하세요.

감사합니다,

Gary Jackson
영업 관리자
Quantum Solutions`,

  koreanNouns: `November 28, 2052

George Thompson
707 Maple Road, Apt 8B
Lakeside, CA 90235

Dear Mr. Thompson, 

I am thrilled to introduce our latest product, QuantumEase Pro, to you. Our team has been working <mark>쉬지 않고</mark> over the past few months to develop QuantumEase Pro, which we believe will revolutionize the ergonomic furniture industry. QuantumEase Pro will provide you with <mark>다양한</mark> unique features designed to make your workspace solutions a <mark>아주 쉬운 일</mark>.

To celebrate QuantumEase Pro's launch, we offer an exclusive introductory promotion for early adopters. For the first month of release, we are offering a 15% discount off the regular price of QuantumEase Pro. This is a limited-time offer, so don't miss this opportunity to start benefiting from QuantumEase Pro.

Please do not hesitate to get in touch if you have any questions or want to order QuantumEase Pro. Remember, the discount is only available for a limited time, so act quickly to ensure you don't miss out.

Sincerely, 

Gary Jackson
Sales Manager
Quantum Solutions`,

  wordPairs: {
    tirelessly: "쉬지 않고",
    "a range of": "다양한",
    breeze: "아주 쉬운 일",
  },

  questions: [],
};

const email23 = {
  id: 23,
  passage: `January 1, 2050

Mr. Thad S. Garza
4854 Roy Alley
Denver, CO 80205

Dear Mr. Garza,

This letter is to propose to you the details of our <mark>contractual</mark> agreement. It will serve as a legally binding document, clearly <mark>outlining</mark> the responsibilities and <mark>obligations</mark> each <mark>party</mark> must fulfill during the course of the agreement.

The terms and conditions and the details of the project or service are detailed in the attached document titled 'Contract Terms.' Please review this document carefully. By signing this letter, you acknowledge your understanding and acceptance of the contract's terms.

We look forward to entering this contract with you and are excited about its potential. Please sign and return a copy of this letter to confirm your acceptance of the agreement.

Thank you in advance for your cooperation.

Sincerely,

John R. Love
HR Manager
Beacon Connect Solutions`,

  translation: `2050년 1월 1일

Thad S. Garza 님
4854 Roy Alley
Denver, CO 80205

Garza 님께,

이 편지는 우리의 계약 합의 세부 사항을 제안하기 위한 것입니다. 이는 법적 구속력이 있는 문서로서, 계약 기간 동안 각 당사자가 이행해야 할 책임과 의무를 명확히 설명합니다.

계약 조건 및 프로젝트 또는 서비스의 세부 사항은 '계약 조건'이라는 제목의 첨부 문서에 자세히 설명되어 있습니다. 이 문서를 주의 깊게 검토해 주십시오. 이 편지에 서명함으로써, 귀하는 계약 조건에 대한 이해와 수락을 인정하게 됩니다.

우리는 귀하와 이 계약을 체결하기를 기대하며 그 잠재력에 대해 기대하고 있습니다. 계약 수락을 확인하기 위해 이 편지의 사본에 서명하여 반환해 주시기 바랍니다.

협조에 미리 감사드립니다.

감사합니다,

John R. Love
인사 관리자
Beacon Connect Solutions`,
  koreanNouns: `January 1, 2050

Mr. Thad S. Garza
4854 Roy Alley
Denver, CO 80205

Dear Mr. Garza,

This letter is to propose to you the details of our <mark>계약의</mark> agreement. It will serve as a legally binding document, clearly <mark>설명하는</mark> the responsibilities and <mark>의무</mark> each <mark>당사자</mark> must fulfill during the course of the agreement.

The terms and conditions and the details of the project or service are detailed in the attached document titled 'Contract Terms.' Please review this document carefully. By signing this letter, you acknowledge your understanding and acceptance of the contract's terms.

We look forward to entering this contract with you and are excited about its potential. Please sign and return a copy of this letter to confirm your acceptance of the agreement.

Thank you in advance for your cooperation.

Sincerely,

John R. Love
HR Manager
Beacon Connect Solutions`,

  wordPairs: {
    contractual: "계약의",
    outlining: "설명하는",
    obligations: "의무",
    party: "당사자",
  },

  questions: [],
};

export const businessEmailQuestions = [
  email1,
  email2,
  email3,
  email4,
  email5,
  email6,
  email7,
  email8,
  email9,
  email10,
  email11,
  email12,
  email13,
  email14,
  email15,
  email16,
  email17,
  email18,
  email19,
  email20,
  email21,
  email22,
  email23,
];
